import React from "react";
import { Checkbox, Collapse, Divider, Modal, Popover } from "antd";
import { observer } from "mobx-react-lite";
import { useMst } from "../../store/root";
import styles from "./Modal.module.scss";
import {
  continueRender,
  HEADER_TITLES,
  testBeforeRender,
  WarningErrors,
  WarningLayers,
} from "../../jsxProviders";
import { MainButton, TextButton } from "../baseComponents";
import { analyticsInstance } from "../../analytics/analyticsCtrls";
import { InfoText } from "../InfoText/InfoText";
import { InfoIcon, WarningIcon } from "../baseComponents/Icons";
import { fileFormat } from "../../store/utils/utilMethods";
import { ModalTopBar } from "./ModalTopBar";
import {
  warningLayersDescMap,
  warningLayersFixDescMap,
} from "../../utils/errors";
const { Panel } = Collapse;

export const WarningModal = observer(() => {
  const {
    uiStore: { warningData, warningModalVisible, setWarningModalHidden },
    compositionStore: {
      setRenderedCompositions,
      compositionCurrentlyRendering,
    },
  } = useMst();
  const typedWarningData = (warningData || []) as WarningLayers;

  const [acceptCondition, setAcceptCondition] = React.useState(false);
  const handleContinue = () => {
    continueRender();
    setWarningModalHidden();
  };

  const cancelRender = () => {
    setRenderedCompositions(compositionCurrentlyRendering.id, false);
    analyticsInstance.sendAnalytics("render", {
      val: "cancel",
      sceneName: compositionCurrentlyRendering.name,
    });
    setWarningModalHidden();
    testBeforeRender();
  };

  const infoContent = (name: string) => (
    <div style={{ backgroundColor: "#FABB36" }}>
      <div style={{ display: "flex", marginRight: "0.5rem" }}>
        <div style={{ color: "black", marginRight: "1rem" }}>
          <WarningIcon />
        </div>
        <h3 style={{ fontSize: "10px", fontWeight: "bold" }}>
          {warningLayersDescMap.get(name)}
        </h3>
      </div>
      <Divider />
      <p style={{ fontSize: "10px", color: "black" }}>
        {warningLayersFixDescMap.get(name)}
      </p>
    </div>
  );

  const warningDataPerType: Record<WarningErrors, string[]> = {
    [WarningErrors.videoOrder]: [],
  };
  if (typedWarningData) {
    typedWarningData?.forEach((f) => {
      const problemType = f.warningType;
      if (!warningDataPerType[problemType]) {
        warningDataPerType[problemType] = [];
      }
      if (!warningDataPerType[problemType].includes(f.layerName)) {
        warningDataPerType[problemType].push(f.layerName);
      }
    });
  }
  const header = (type: WarningErrors) => {
    return (
      <div style={{ display: "inline-block", width: "95%" }}>
        <div style={{ display: "flex", placeContent: "space-between" }}>
          <div className="left">{HEADER_TITLES[type]}</div>
          <div className="right">
            <Popover
              placement="left"
              key={type}
              content={infoContent(type)}
              className={styles.Right}
              overlayClassName={styles.overlayClassName}
            >
              <div>
                <InfoIcon />
              </div>
            </Popover>
          </div>
        </div>
      </div>
    );
  };
  return (
    <Modal
      className={[styles.Modal, styles.FileSize, styles.NewProjectModal, styles.WarningLayers].join(
        " "
      )}
      visible={warningModalVisible}
      onOk={handleContinue}
      onCancel={cancelRender}
      footer={false}
    >
      <ModalTopBar
        icon={
          <div style={{ color: "#FABB36" }}>
            <WarningIcon />
          </div>
        }
      />
      <p className={styles.Extra}>Looks like you have some warnings</p>
      <div className={styles.Info}>
        <Collapse bordered={false} ghost>
          {Object.entries(warningDataPerType).map(([type, layerNames]) => (
            <Panel header={header(type as WarningErrors)} key={type}>
              {layerNames.map((name) => (
                <div className={styles.Information} key={name}>
                  <p title={name} className={styles.Left}>
                    {name}
                  </p>
                </div>
              ))}
            </Panel>
          ))}
        </Collapse>
      </div>
      <div className={styles.Checks}>
        <Checkbox
          checked={acceptCondition}
          onChange={(e) => setAcceptCondition(e.target.checked)}
        >
          I understand that rendering may affect the quality and performance of
          my video
        </Checkbox>
      </div>
      <div className={[styles.Buttons, styles.MarginTop].join(" ")}>
        <TextButton onClick={cancelRender} text="cancel" />
        <MainButton
          disabled={!acceptCondition}
          onClick={handleContinue}
          text="Continue"
        />
      </div>
    </Modal>
  );
});
